export default "__VITE_ASSET__Dgq8EvRA__"